import type { IComponentOptions, IControllerConstructor, Injectable } from "angular";

import "./ExtendedSearchOverview.html";
import "./ExtendedSearchOverview.scss";
import { ExtendedSearchOverviewComponentController } from "./ExtendedSearchOverviewComponentController";

export class ExtendedSearchOverviewComponent implements IComponentOptions {
    public bindings: any;

    public controller: Injectable<IControllerConstructor>;

    public templateUrl: string;

    constructor() {
        this.bindings = {
            onCloseModal: "&",
            searchString: "<",
        };
        this.controller = ExtendedSearchOverviewComponentController;
        this.templateUrl = "/App/Modules/Gui/Components/Search/ExtendedSearchOverview/ExtendedSearchOverview.html";
    }
}
